/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum ReservationState {
  RESERVED = 0,
  QUEUED = 1,
  IN_PROGRESS = 2,
  DONE = 3,
  SKIPPED = 4,
}

export namespace ReservationState {
  export function values() {
    return Object.keys(ReservationState).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
